<template>
  <div>
    <div v-if="!showNoResultAlert">
      <div class="bs-component" v-if="!hideHead">
        <div class="btn-group float-left">
          <mmf-button
              type="edit"
              v-if="!disableEdit"
              :showName="true"
              v-bind:class="'btn btn-outline-primary btn-sm'"
              :disabled="actionDisabled('edit')"
              v-on:click="MMFEdit(entity)"
              v-show="!isIgnoreEdit"
          ></mmf-button>
          <mmf-button
              type="delete"
              v-if="!disableDelete"
              :showName="true"
              v-bind:class="'btn btn-outline-primary btn-sm'"
              :disabled="actionDisabled('delete')"
              v-on:click="MMFDelete(entity)"
              v-show="!isIgnoreDelete"
          ></mmf-button>
          <slot
              name="btnList"
              :checkedItems="checkedItems"
              :checkedLength="(checkedItems||[]).length"
          ></slot>
        </div>
      </div>
      <div class="col-lg-12" v-if="!hideHead">
        <div class="float-lg-right">
          <mmf-button
              type="export"
              v-bind:class="'btn btn-outline-primary'"
              v-on:click="tableExport(entity)"
          ></mmf-button>
        </div>
      </div>
      <div class="clearfix">&nbsp;</div>
      <div class="fixed-header-top-div">
        <div :class="{'fixed-header-container':true,'half-height-table':halfHeight}">
          <table class="table table-striped table-hover">
            <thead>
            <tr>
              <th v-for="col in tableColumns" v-bind:key="col.key">
                <!--                  {{ $t(col.label) }}-->
                <div
                    v-show="!isIgnoreCheckBox"
                    scope="col"
                    v-if="col.form.type == 'checkbox'"
                    style="margin-left:auto"
                >
                  <!-- singleChoice 只有不是单选模式时，才有全选框 -->
                  <b-form-checkbox
                      v-if="!singleChoice"
                      @click.native.stop
                      @change="toggleAll"
                      inline
                  />
                </div>
                <!-- sortable -->
                <div
                    scope="col"
                    @click="sortByKey(col.key)"
                    v-else-if="col.sortable"
                >{{ $t(col.label) }} ↕
                </div>
                <div scope="col" v-else>{{ $t(col.label) }}</div>
              </th>
            </tr>
            </thead>
            <tbody v-if="newRows.length > 0">
            <tr v-for="(row, index) in newRows" v-bind:key="index">
              <td v-for="col in tableColumns" v-bind:key="col.key">
                <div v-if="col.form.type == 'checkbox'"></div>
                <div v-else-if="col.form.type == 'modalEdit'">
                  <b-btn
                      v-if="isRowEditing(row)"
                      size="sm"
                      @click="showModalEditValue({action:'edit', scope:'add'}, row, col)"
                  >{{ $t("btn.basic.edit") }}
                  </b-btn>
                  <b-btn
                      v-else
                      size="sm"
                      @click="showModalEditValue({action:'view', scope:'add'}, row, col)"
                  >{{ $t("btn.basic.show") }}
                  </b-btn>
                </div>
                <div v-else-if="col.form.type == 'actions'">
                  <mmf-button
                      type="cancel"
                      v-bind:class="'btn btn-outline-secondary btn-sm mr-1'"
                      v-on:click="cancelAddedRow(row)"
                  ></mmf-button>
                  <mmf-button
                      type="check"
                      v-bind:class="'btn btn-outline-primary btn-sm'"
                      v-on:click="saveAddedRow(row)"
                  ></mmf-button>
                </div>
                <div v-else>
                  <mmf-form-helper
                      :metadata="col"
                      :isEditing="isRowEditing(row)"
                      :value="row[col.key]"
                      @input="changeNewEntityAttribute(col, row, $event)"
                  ></mmf-form-helper>
                </div>
              </td>
            </tr>
            </tbody>
            <tbody>
            <tr v-for="row in rows" v-bind:key="row.id">
              <td
                  v-for="col in tableColumns"
                  v-bind:key="col.key"
                  v-bind:style="{ background: rowStatus(row)  }"
              >
                <div v-show="!isIgnoreCheckBox" v-if="col.form.type == 'checkbox'">
                  <b-form-checkbox
                      @click.native.stop
                      :checked="isChecked(row)"
                      @change="select({item: row, module:entity})"
                      :disabled="isRowEditing(row)"
                      inline
                  />
                </div>
                <div v-else-if="col.form.type == 'modalEdit'">
                  <b-btn
                      v-if="isRowEditing(row)"
                      size="sm"
                      @click="showModalEditValue({action:'edit', scope:'edit'}, row, col)"
                  >{{ $t("btn.basic.edit") }}
                  </b-btn>
                  <b-btn
                      v-else
                      size="sm"
                      @click="showModalEditValue({action:'view', scope:'edit'}, row, col)"
                  >{{ $t("btn.basic.show") }}
                  </b-btn>
                </div>
                <div v-else-if="col.form.type == 'detailTable'">
                  <b-btn
                      :disabled="isRowEditing(row)"
                      size="sm"
                      @click="showDetailTable(row, col)"
                  >{{ $t("btn.basic.show") }}
                  </b-btn>
                </div>
                <!-- luanwf -->
                <div v-else-if="col.form.type == 'showcol'">
                  <b-btn
                      :disabled="isRowEditing(row)"
                      size="sm"
                      @click="showCol(row, col)"
                  >{{ $t("btn.basic.show") }}
                  </b-btn>
                </div>

                <div v-else-if="col.form.type == 'reportConfig'">
                  <b-btn
                      :disabled="isRowEditing(row)"
                      size="sm"
                      @click="showReportConfig(row)"
                  >{{ $t("btn.basic.show") }}
                  </b-btn>
                </div>
                <div v-else-if="col.form.type == 'actions'">
                  <!-- 保存 √  / 取消 × -->
                  <div v-if="isRowEditing(row)">
                    <mmf-button
                        type="cancel"
                        v-bind:class="'btn btn-outline-secondary btn-sm mr-1'"
                        v-on:click="cancelRowEdit(row)"
                    ></mmf-button>
                    <mmf-button
                        type="check"
                        v-bind:class="'btn btn-outline-primary btn-sm'"
                        v-on:click="saveEditedRow(row)"
                    ></mmf-button>
                  </div>
                  <!-- 编辑 / 删除 / 显示 -->
                  <div class="btn-group" v-else>
                    <mmf-button
                        v-if="!disableInlineEdit"
                        type="edit"
                        v-bind:class="'btn btn-outline-primary btn-sm'"
                        v-on:click="editRow(row)"
                    ></mmf-button>
                    <mmf-button
                        v-if="!disableInlineDelete"
                        type="delete"
                        v-bind:class="'btn btn-outline-primary btn-sm'"
                        v-on:click="delRow(row)"
                    ></mmf-button>
                    <mmf-button
                        v-if="!disableInlineView"
                        type="showEntity"
                        v-bind:class="'btn btn-outline-primary btn-sm'"
                        @click="showEntity(row)"
                    ></mmf-button>
                  </div>
                </div>
                <div v-else-if="col.form.type == 'formatter'">
                  <b-button
                      v-for="button in buttons"
                      v-bind:key="button.methodName"
                      v-on:click="operate(button.methodName,row)"
                      class="mr-2"
                  >{{ button.name }}
                  </b-button>
                </div>
                <div v-else>
                  <div
                      :class="getStyle(row, col)"
                      v-bind:style="{ color:colStatus(col,row[col.key])  }"
                  >
                    <mmf-form-helper
                        :metadata="col"
                        :isEditing="isRowEditing(row, col)"
                        :value="row[col.key]|formatFloat"
                        @input="changeEntityAttribute(col, row, $event)"
                        @changeBooleanValue="changeBooleanValue(col, row, $event)"
                    ></mmf-form-helper>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <mmf-pagination
          :entity="entity"
          :totalRows="totalRows"
          :perPage="rowsPerPage"
          v-on:change:perpage="rowsPerPage = $event"
          :currentPage="currentPage"
          v-on:change:page="currentPage = $event"
      ></mmf-pagination>
    </div>
    <form id="my_form"></form>
    <mmf-no-result-alert :isVisible="showNoResultAlert"></mmf-no-result-alert>
    <b-modal
        ref="modalViewer"
        centered
        :title="$t(modelEditColumnLabel)"
        size="lg"
        ok-only
        :ok-title="$t('lbl.basic.close')"
    >
      <b-card>
        <b-row class="mb-2">
          <!-- <p class="my-4" v-html="modalEditValue"></p> -->
          <b-table :items="str2obj(modalEditValue)"></b-table>
        </b-row>
      </b-card>
    </b-modal>
    <b-modal
        ref="detailTable"
        centered
        :title="$t(modelEditColumnLabel)"
        size="lg"
        ok-only
        :ok-title="$t('lbl.basic.close')"
    >
      <b-card>
        <b-table striped hover :items="detailItems" :fields="detailFields"></b-table>
      </b-card>
    </b-modal>
    <!--luanwf-->
    <b-modal
        ref="showColTable"
        centered
        :title="$t(modelEditColumnLabel)"
        size="lg"
        ok-only
        :ok-title="$t('lbl.basic.close')"
    >
      <b-card>
        <b-list-group>
          <b-list-group-item v-for="(item,index) in showColItems" :key="index">{{ item }}</b-list-group-item>
        </b-list-group>
      </b-card>
    </b-modal>
    <b-modal
        ref="reportConfig"
        centered
        :title="$t(modelEditColumnLabel)"
        size="lg"
        ok-only
        :ok-title="$t('lbl.basic.close')"
    >
      <Json ref="jsonEdit" :value="reportConfig"/>
    </b-modal>
    <b-modal
        ref="modalEditor"
        centered
        :title="modelEditColumnLabel"
        size="lg"
        :ok-title="$t('btn.basic.save')"
        :cancel-title="$t('lbl.basic.cancel')"
        @ok="saveModalEditValue"
    >
      <div class="d-block text-center">
        <textarea v-model="modalEditValue" style="width: 100%" rows="15"/>
      </div>
    </b-modal>
    <mmf-table-export
        :entity="entity"
        ref="exportConfirm"
        :config="{perPageSize:rowsPerPage, totalRows}"
    ></mmf-table-export>
    <echart v-if="rows.length !=0" :rows="rows" :entity="entity"></echart>
  </div>

</template>

<script>
import echart from '@/components/MmfEcharts/MmfEcharts.vue'
import MmfButton from "@/components/MmfButton";
import MmfNoResultAlert from "@/components/MmfNoResultAlert";
import MmfPagination from "@/components/MmfPagination";
import MmfFormHelper from "@/components/MmfFormHelper";
// import MmfLimitationAlert from "@/components/MmfLimitationAlert";
import {mapActions} from "vuex";
// import { createHelpers } from "vuex-map-fields";
import model from "@/model/index";
import str2obj from "@/utils/str2obj";
import MmfTableExport from "@/components/MmfTableExport";
import Json from "@/views/report/jsonEdit/JsonEdit";
import _ from "lodash";

let checkboxField = {
  key: "state",
  label: "state",
  isControlField: true,
  form: {
    type: "checkbox"
  }
};

let actionField = {
  key: "actions",
  label: "Actions",
  isActionField: true,
  form: {
    type: "actions"
  }
};

export default {
  name: "mmf-table",
  data() {
    return {

      modalEditValue: "",
      modelEditColumnLabel: "",
      modelEditColumnKey: "",
      modelEditMode: {},
      modalEditRow: null,
      detailItems: [],
      detailFields: [],
      showColItems: [],
      showColFields: [],
      reportConfig: null,
      upOrDown: {},
      dataField: ""
    };
  },
  components: {
    echart,
    MmfButton,
    MmfNoResultAlert,
    MmfPagination,
    MmfFormHelper,
    // MmfLimitationAlert,
    MmfTableExport,
    Json
  },
  props: {
    actions: {
      main: String,
      default: Boolean,
      more: Array
    },
    entity: String,
    checkboxColumnDisabled: {
      type: Boolean,
      default: false
    },
    inlineActionsDisabled: {
      type: Boolean,
      default: false
    },
    // 是否启用单选模式，启动后将最多选择一个选项
    singleChoice: {
      type: Boolean,
      default: false
    },
    disableEdit: {
      type: Boolean,
      default: false
    },
    disableDelete: {
      type: Boolean,
      default: false
    },
    hideHead: {
      type: Boolean,
      default: false
    },
    halfHeight: {
      type: Boolean,
      default: false
    },
    isIgnoreEdit: {
      type: Boolean,
      default: false
    },
    isIgnoreDelete: {
      type: Boolean,
      default: false
    },
    isIgnoreCheckBox: {
      type: Boolean,
      default: false
    },
    buttons: Array,
    isUsingCustomMethod: {
      type: Boolean,
      default: false
    },
    // 隐藏行内编辑
    disableInlineEdit: {
      type: Boolean,
      default: false
    },
    // 隐藏行内删除
    disableInlineDelete: {
      type: Boolean,
      default: false
    },
    // 隐藏行内查看
    disableInlineView: {
      type: Boolean,
      default: false
    },
    statusOrResult: {
      type: Array,
      default: null
    },
    formulaDetailSave: String
  },
  computed: {

    tableColumns() {
      let gridFields = model[this.entity]
          .gridFields()
          .filter(v => !v.notInTable);
      let entityData = [];
      if (!this.checkboxColumnDisabled) {
        entityData.push(checkboxField);
      }
      entityData = entityData.concat(gridFields);
      if (!this.inlineActionsDisabled) {
        entityData.push(actionField);
      }
      return entityData;
    },
    rows: {
      get() {
        return this.$store.state[this.entity].rows;
      },
      set(value) {
        this.$store.commit(this.entity + "/setRows", value);
      }
    },
    newRows: {
      get() {
        return this.$store.state[this.entity].newRows;
      }
    },
    editingRows: {
      get() {
        return this.$store.state[this.entity].editingRows;
      }
    },
    checkedItems: {
      get() {
        return this.$store.state[this.entity].checkedItems;
      },
      set(value) {
        this.$store.commit(this.entity + "/setCheckedItems", value);
      }
    },
    currentPage: {
      get() {
        return this.$store.state[this.entity].currentPage;
      },
      set(value) {
        this.$store.commit(this.entity + "/setCurrentPage", value);
      }
    },
    rowsPerPage: {
      get() {
        return this.$store.state[this.entity].fixedFilter.numRegPag;
      },
      set(value) {
        this.$store.commit(this.entity + "/setRowsPerPage", value);
        this.$store.commit(this.entity + "/setCurrentPage", 1);
      }
    },
    totalRows() {
      return this.$store.state[this.entity].fixedFilter.totalReg;
    },
    newEntity() {
      return model[this.entity].newEntity();
    },
    showNoResultAlert() {
      return this.$store.state[this.entity].showNoResultAlert;
    },
    itemLimitationAlert: {
      get() {
        return this.$store.state[this.entity].itemLimitationAlert;
      },
      set(value) {
        this.$store.commit(this.entity + "/setItemLimitationAlert", value);
      }
    }
  },
  methods: {
    rowStatus(row) {
      if (this.statusOrResult != null) {
        for (var index in this.statusOrResult) {
          if (
              row[Object.keys(this.statusOrResult[index])[0]] != null &&
              row[Object.keys(this.statusOrResult[index])[0]] ==
              this.statusOrResult[index][
                  Object.keys(this.statusOrResult[index])[0]
                  ]
          ) {
            return this.statusOrResult[index][
                Object.keys(this.statusOrResult[index])[1]
                ];
          }
        }
      }
    },
    colStatus(col, value) {
      if (this.dataField != "") {
        var attributes = this.dataField.map(x => {
          return x.attribute;
        });
        if (attributes.indexOf(col.key) >= 0) {
          var attribute = this.dataField.filter(x => x.attribute == col.key);
          if (value > attribute[0].upperLimit) {
            return attribute[0].upperColor;
          }
          if (value < attribute[0].lowerLimit) {
            return attribute[0].lowerColor;
          }
        }
        return null;
      }
    },
    sortByKey(key) {
      const upOrDown = this.upOrDown;
      let result = _.sortBy([...this.rows], a => a[key]);
      if (upOrDown[key]) {
        result = result.reverse();
      }
      upOrDown[key] = !upOrDown[key];
      this.rows = result;
    },
    changeBooleanValue(col, row, $event) {
      let key = col.key;
      let newValue = $event;
      this.$store.commit(this.entity + "/addSwitchModeList", {
        row,
        key,
        newValue
      });
    },
    changeEntityAttribute(col, row, $event) {
      var splited = col.key.split(".");
      var key = col.key;
      var newValue = $event;
      if (splited.length > 1) {
        var baseAttribute = this.entityObject[splited[0]];

        baseAttribute =
            baseAttribute !== "" ? Object.assign({}, baseAttribute) : {};

        var newAttribute = baseAttribute;
        for (var i = 1; i < splited.length; i++) {
          var iKey = splited[i];
          newAttribute[iKey] = i === splited.length - 1 ? $event : {};
          newAttribute = newAttribute[iKey];
        }

        key = splited[0];
        newValue = baseAttribute;
      }

      this.$store.commit(this.entity + "/setRow", {
        row,
        key,
        newValue
      });
      if (col.form.type === "entitySelect") {
        var id = $event ? $event : 0;
        if (col.form.onChangeDispatchAction) {
          for (let i in col.form.onChangeDispatchAction) {
            this.$store.dispatch(col.form.onChangeDispatchAction[i], {
              id,
              mainEntity: this.entity,
              type: "entity"
            });
          }
        }
      }
    },
    toggleAll(checked) {
      if (!checked) {
        this.$store.commit(this.entity + "/setCheckedItems", []);
        return;
      }

      var auxVector = [];
      for (let i in this.$store.state[this.entity].rows)
        auxVector.push(this.$store.state[this.entity].rows[i].id);

      this.$store.commit(this.entity + "/setCheckedItems", auxVector);
    },
    showEntity(row) {
      this.$modal.entityModal(this.entity, row);
    },
    showModalEditValue(mode, row, col) {
      this.modelEditMode = mode;
      this.modalEditValue = row[col.key];
      this.modelEditColumnLabel = col.label;
      this.modelEditColumnKey = col.key;
      this.modalEditRow = row;
      if (mode.action == "edit") {
        this.$refs.modalEditor.show();
      } else {
        this.$refs.modalViewer.show();
      }
    },
    showDetailTable(row, col) {
      this.modelEditColumnLabel = col.label;
      let arr = this.$store.state[this.entity][`${col.key}Label`];
      this.detailItems = row[col.key].filter(v => typeof v == "object");
      this.detailFields = arr.map(v => {
        return {
          key: v.key,
          label: this.$t(v.label)
        };
      });
      this.$refs.detailTable.show();
    },
    showCol(row, col) {
      this.modelEditColumnLabel = col.label;
      let arr = row[col.key];
      this.showColItems = arr;
      this.$refs.showColTable.show();
    },
    showReportConfig(row) {
      this.reportConfig = JSON.parse(row.templateConfig);
      // this.$refs.jsonEdit.setValue(this.reportConfig);
      // this.$refs.jsonEdit.setReadOnly(true);
      this.$refs.reportConfig.show();
      // setTimeout(() => {
      //     this.$refs.jsonEdit.refresh();
      // }, 10);
      setTimeout(() => {
          this.$refs.jsonEdit.refresh();
      }, 100);
    },
    actionDisabled(type) {
      if (type == "delete") {
        return this.disableDelete || this.checkedItems.length == 0;
      } else {
        return this.disableEdit || this.checkedItems.length != 1;
      }
    },
    addRow() {
      if (this.newRows.length == 0) {
        var newRow = model[this.entity].newEntity();
        this.$store.commit(this.entity + "/addNewRow", newRow);
      }
    },
    saveAddedRow(row) {
      this.$store.commit(this.entity + "/setEntity", row);
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.$store.dispatch("base/MMFSaveInline", this.entity);
          this.$store.commit(this.entity + "/removeNewRow", row);
        }
      });
    },
    saveEditedRow(row) {
      const saveEntity = this.editingRows.filter(r => r.id === row.id)[0];
      this.$store.commit(this.entity + "/setEntity", saveEntity);
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          if (this.isUsingCustomMethod) {
            console.log(this.formulaDetailSave);
            const formulaDetailSaveName = this.formulaDetailSave;
            this.$parent[formulaDetailSaveName](this.entity);
            this.cancelRowEdit(row);
          } else {
            this.$store.dispatch("base/MMFSaveInline", this.entity).then(() => {
              this.rows = this.rows.map(v => {
                if (v.id == row.id) {
                  return {...saveEntity};
                } else {
                  return v;
                }
              });
            });
            this.cancelRowEdit(row);
          }

          // this.newRows.pop();
        }
      });
    },
    cancelAddedRow(row) {
      this.$store.commit(this.entity + "/removeNewRow", row);
    },
    cancelRowEdit(row) {
      this.$store.commit(this.entity + "/removeEditingRow", row);
    },
    editRoweditRow(row) {
      this.$store.commit(this.entity + "/addEditingRow", row);
    },
    delRow(row) {
      var modifiedRows = this.rows.filter(x => x.id !== row.id);
      this.$store.commit(this.entity + "/setRows", modifiedRows);
    },
    saveModalEditValue() {
      if (this.modelEditMode.scope == "edit") {
        this.$store.commit(this.entity + "/setRow", {
          row: this.modalEditRow,
          key: this.modelEditColumnKey,
          newValue: this.modalEditValue
        });
      } else {
        this.$store.commit(this.entity + "/setNewRow", {
          row: this.modalEditRow,
          key: this.modelEditColumnKey,
          newValue: this.modalEditValue
        });
      }
    },
    changeNewEntityAttribute(col, row, $event) {
      this.$store.commit(this.entity + "/setNewRow", {
        row: row,
        key: col.key,
        newValue: $event
      });
    },
    changeEditEntityAttribute(col, row, $event) {
      this.$store.commit(this.entity + "/setRow", {
        row: row,
        key: col.key,
        newValue: $event
      });
    },
    /**
     * col  可选参数 GridField 类型
     */
    isRowEditing(row, col) {
      if (col && col.alwaysEdit) {
        return true;
      }
      if (row.id == null) {
        return true;
      }
      let result = this.editingRows.some(r => r.id == row.id);
      return result;
    },
    isChecked(row) {
      let result = this.checkedItems.some(rowid => rowid == row.id);
      return result;
    },
    str2obj(str) {
      if (typeof str === "string") {
        // 推荐传入 string 类型
        return str2obj(str);
      } else {
        return str;
      }
    },
    /**
     * 选择
     * 会根据 是否单选 来执行不同的处理
     */
    select(args) {
      if (this.singleChoice) {
        const checked = this.isChecked(args.item);
        this.toggleAll(false); // 清空所有选项
        // checkbox 的 checked 与否并不完全由 isChecked 函数决定
        // 特别是触发事件的这个 checkbox ，
        // 点击后其选择状态必定被修改，与 isChecked 完全无关
        // 所以，这里使用 MMFselectRow(args) 并不是为了修改其状态
        // 而是为了让 视图 和 仓库 的状态同步
        if (!checked) {
          this.MMFselectRow(args);
        }
      } else {
        this.MMFselectRow(args);
      }
    },
    getStyle(row, col) {
      let key = col.key;
      let value = row[key];
      let ops = col && col.form && col.form.options;
      let style = ops && ops.filter(v => v.value == value).map(v => v.style)[0];
      // console.log({ value, style, ops });
      if (style) {
        return {
          status: true,
          ["status-" + style]: true
        };
      }
    },
    operate(name, row) {
      this.$parent[name](row);
    },
    tableExport() {
      this.$refs.exportConfirm.show();
    },
    ...mapActions("base", [
      "MMFselectRow",
      "MMFSaveInline",
      "MMFEdit",
      "MMFDelete",
      "MMFExport"
    ])
  },
  mounted() {
    //todo: 暂时屏蔽，因为准备把mmf-adm启用了，等回头在em-admin补上这个接口再恢复
    // this.$store
    //     .dispatch("api/get", {
    //         url:
    //             process.env.VUE_APP_ADM_API_URL +
    //             "adm-service/adm" +
    //             "/dataField/findDataField" +
    //             "?" +
    //             "name=" +
    //             this.entity
    //     })
    //     .then(response => {
    //         this.dataField = response;
    //     });
  }
};
</script>
